import { useAuth0 } from '@auth0/auth0-react';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../model/store';
import { userSlice } from '../model/userSlice';

export const useUserRoles = () => {
  const roles = useSelector((state: RootState) => state.user.profile?.roles);

  const [loading, setLoading] = useState(_.isEmpty(roles));

  const dispatch = useDispatch();
  const { getIdTokenClaims, user } = useAuth0();

  useEffect(() => {
    (async () => {
      console.log('AUTH0 USER:', user);

      const claims = await getIdTokenClaims();

      let audience = process.env.REACT_APP_AUTH0_AUDIENCE;
      if (!audience?.endsWith('/api')) {
        if (audience?.endsWith('/')) {
          audience = audience.slice(0, -1);
        }
        audience = audience + '/api';
      }

      let claimKey = `${audience}/roles`;

      console.log('CLAIMS:', claims);
      console.log('CLAIM KEY:', claimKey);
      //claimKey = 'https://risenhope.appwrk.com/api/roles';
      const extractedRoles = claims?.[claimKey];

      // Store role for faster evaluation in the future
      dispatch(
        userSlice.actions.receivedUser({
          user: { roles: extractedRoles },
        })
      );

      if (loading) {
        setLoading(false);
      }
    })();
  }, [dispatch, getIdTokenClaims, loading, user]);

  return { loading, roles };
};
